import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e80d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchDetails__head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "searchDetails__head_title" }, "くわしくさがす", -1))
const _hoisted_3 = { class: "searchDetails__contents" }
const _hoisted_4 = { class: "searchDetails__fieldArea" }
const _hoisted_5 = { class: "searchDetails__group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchDetails__name" }, "タイトル", -1))
const _hoisted_7 = { class: "searchDetails__name" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("著 者")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "ちょしゃ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_12 = { class: "searchDetails__item" }
const _hoisted_13 = { class: "searchDetails__name" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("出   版   社")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "しゅっぱんしゃ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_18 = { class: "searchDetails__name" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("刊  行  年")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "かんこうねん", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_23 = { class: "searchDetails__dateWrapper" }
const _hoisted_24 = { class: "searchDetails__date" }
const _hoisted_25 = { class: "searchDetails__date_input" }
const _hoisted_26 = { class: "searchDetails__date_text" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("年")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "ねん", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("〜")
const _hoisted_32 = { class: "searchDetails__date_input" }
const _hoisted_33 = { class: "searchDetails__date_text" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("年")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "ねん", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_38 = {
  key: 0,
  class: "searchDetails__date_error"
}
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "searchDetails__name searchDetails__name--radioGroup" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("学 年")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "がくねん", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_47 = { class: "searchDetails__radioGroup" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchDetails__name searchDetails__name--radioGroup searchDetails__name--firstLayers" }, " ジャンル ", -1))
const _hoisted_49 = { class: "searchDetails__radioGroup" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchDetails__name searchDetails__name--radioGroup" }, [
  /*#__PURE__*/_createTextVNode(" くわしい"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ジャンル ")
], -1))
const _hoisted_51 = { class: "searchDetails__radioGroup" }
const _hoisted_52 = { class: "searchDetails__name searchDetails__name--radioGroup" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("音 声")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "おんせい", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode("読")
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "よ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_62 = /*#__PURE__*/_createTextVNode("み")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("上")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "あ", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode("げ ")
const _hoisted_68 = { class: "searchDetails__radioGroup" }
const _hoisted_69 = { class: "searchDetails__name searchDetails__name--radioGroup" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("公開")
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "こうかい", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode("終了")
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "しゅうりょう", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode("日")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "び", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_83 = { class: "searchDetails__radioGroup" }
const _hoisted_84 = { class: "searchDetails__actionArea" }
const _hoisted_85 = { class: "searchDetails__button_inner" }
const _hoisted_86 = { class: "searchDetails__button_icon" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "searchDetails__button_text" }, "さがす", -1))
const _hoisted_88 = {
  key: 0,
  class: "dialogArea"
}

import {
  nextTick,
  onMounted,
  ref,
  computed,
  inject,
} from 'vue'
import { useRouter } from 'vue-router'

import { useDialog } from '@/composables/useDialog'
import {
  Grade,
  GRADE_LIST,
  ContentsStyle,
  CONTENTS_STYLE_LIST,
  ReleaseEndDate,
  RELEASE_END_DATE_LIST,
} from '@/constants'
import { ORDERS } from '@/constants/search'
import ValidationHelper from '@/helpers/ValidationHelper'
import { useKeyboardStore } from '@/store/keyboard'

import {
  GetPublisherItem,
  GetFirstLayerResponseItem,
  GetSecondaryLayerResponseItem,
} from '@/models/ApiIF'

import AppButton from '@/components/AppButton/AppButton.vue'
import AppCheckbox from '@/components/AppCheckbox/AppCheckbox.vue'
import AppInput from '@/components/AppInput/AppInput.vue'
import AppImage from '@/components/AppImage/AppImage.vue'
import AppSelect from '@/components/AppSelect/AppSelect.vue'
import RadioGroup from '@/components/RadioGroup/RadioGroup.vue'
import SlotModal from '@/components/SlotModal/SlotModal.vue'
import SlotDialog from '../SlotDialog/SlotDialog.vue'
import ApiHelper from '@/helpers/ApiHelper'
import { useHandleError } from '@/composables/useHandleError'
import InputSettings from '@/models/InputSettings'
import { injectionKeys } from '@/constants/injectionKeys'
import StoreHelper from '@/helpers/StoreHelper'

type selectedFirstLayer = GetFirstLayerResponseItem

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDetails',
  emits: ['close'],
  setup(__props, { emit }) {

/**
 * SearchDetails.
 *
 * くわしくさがす.
 */

const { handleErrors } = useHandleError()
const $validation = inject<ValidationHelper>(injectionKeys.$validation)

const router = useRouter()



// 地域の資料のみをさがす
const area = ref(false)
const onChangeArea = (params: { name: string; checked: boolean }) => {
  area.value = params.checked
}

const disabledItem = computed(() => {
  return {
    className: {
      disabled: area.value,
    },
  }
})

// 物語以外の本をさがす
const learning = ref(false)
const onChangeLearning = (params: { name: string; checked: boolean }) => {
  learning.value = params.checked
}

const title = ref('') // タイトル
const author = ref('') // 著者
const dateFrom = ref('') // 刊行年(From)
const dateTo = ref('') // 刊行年(To)

// 出版社
const publisherList = ref<GetPublisherItem[]>([])
const publisher = ref<GetPublisherItem['publisherId']>(null)

// 学年
const gradeList = GRADE_LIST
const grade = ref<Grade['code']>(gradeList[0].code)
const onChangeGrade = (params: Grade) => {
  grade.value = params.code
}

// ジャンル
const firstLayers = ref<GetFirstLayerResponseItem[]>([])
const first = ref<GetFirstLayerResponseItem['code']>(null)
const onChangeFirst = async (params: GetFirstLayerResponseItem) => {
  first.value = params.code
  await getSecond(params)
  second.value = secondaryLayers.value[0]?.code ?? null
}

// くわしいジャンル
const secondaryLayers = ref<GetSecondaryLayerResponseItem[]>([])
const second = ref<GetSecondaryLayerResponseItem['code']>(null)
const onChangeSecond = (params: GetSecondaryLayerResponseItem) => {
  second.value = params.code
}

// 音声読み上げ
const contentsStyleList = CONTENTS_STYLE_LIST
const contentsStyle = ref<ContentsStyle['code']>(contentsStyleList[0].code)
const onChangeContentsStyle = (params: ContentsStyle) => {
  contentsStyle.value = params.code
}

// 公開終了日が決まっている本のみを追加
const releaseEndDateList = RELEASE_END_DATE_LIST
const releaseEndDate = ref<ReleaseEndDate['code']>(releaseEndDateList[0].code)
const onChangeReleaseEndDate = (params: ReleaseEndDate) => {
  releaseEndDate.value = params.code
}

// エラーダイアログ
const errorDialog = useDialog()

// さがす
const search = () => {
  if (!isValidAll.value) {
    errorDialog.open()
    return
  }

  const path = '/book_search'
  const searchType = 'detail'
  const query: { [key: string]: string | number | null } = {}

  query.searchType = searchType
  query.title = title.value

  if (!title.value && !author.value) {
    query.order = ORDERS.nOrderReleaseStart.code
  }

  if (area.value) {
    query.area = Number(area.value)
  } else {
    query.author = author.value
    query.dateTo = dateTo.value
    query.dateFrom = dateFrom.value
    query.grade = grade.value
    query.first = first.value
    query.second = second.value
    query.publisher = publisher.value
    query.contentsStyle = contentsStyle.value
    query.releaseEndDate = releaseEndDate.value
    query.learning = Number(learning.value)
  }

  router.push({ path, query })
}

const isValidAll = computed(() => {
  return (
    !titleErrorMessage.value &&
    !authorErrorMessage.value &&
    !dateFromErrorMessage.value &&
    !dateToErrorMessage.value &&
    !dateBetweenErrorMessage.value
  )
})

// とじる
const close = () => {
  emit('close')
}

// ソフトキーボードフォーカス設定
const focusInput = ref()
const focusToInput = () => {
  focusInput.value.querySelector('input').focus()
}
const keyboardStore = useKeyboardStore()
keyboardStore.$subscribe(async (mutation, state) => {
  if (state.isShow) {
    await nextTick()
    focusToInput()
  }
})

onMounted(() => {
  if (keyboardStore.isShow) {
    focusToInput()
  }
})

// ↓ 主にTF様の編集領域
// ------------------------------

const inputSettings: InputSettings = {
  title: {
    name: 'タイトル',
    rules: {
      checkEmoji: true,
      maxLength: 100,
    },
  },
  author: {
    name: '著者',
    rules: {
      checkEmoji: true,
      maxLength: 100,
    },
  },
  dateFrom: {
    name: '刊行年(from)',
    rules: {
      number: true,
      exactLength: 4,
    },
  },
  dateTo: {
    name: '刊行年(to)',
    rules: {
      number: true,
      exactLength: 4,
    },
  },
}

// くわしいジャンル取得
const secondaryLayersMap = new Map<
  string | null,
  GetSecondaryLayerResponseItem[]
>()
const getSecond = async (firstLayer: selectedFirstLayer) => {
  if (secondaryLayersMap.has(firstLayer.code)) {
    secondaryLayers.value = secondaryLayersMap.get(firstLayer.code)!
    return
  }

  secondaryLayers.value = []
  let resSecondaryLayers: GetSecondaryLayerResponseItem[] = []
  if (firstLayer.code !== null) {
    const req = {
      firstLayerCode: firstLayer.code!,
    }
    await ApiHelper.getSecondaryLayer(req)
      .then((res) => {
        resSecondaryLayers = res.secondaryLayers
      })
      .catch((err) => {
        handleErrors(err)
      })
  }
  // 初期値を設定
  resSecondaryLayers.unshift({
    code: null,
    name: 'すべて',
    rubyName: '',
  })
  secondaryLayersMap.set(firstLayer.code, resSecondaryLayers)
  // ジャンルを変更していた場合、画面表示に設定しない
  if (first.value === firstLayer.code) {
    secondaryLayers.value = resSecondaryLayers
  }
}

const initialRequest = async () => {
  firstLayers.value = (await StoreHelper.getAndSetFirstLayerCode())!
  first.value = firstLayers.value[0].code
  getSecond(firstLayers.value[0])

  publisherList.value = (await StoreHelper.getAndSetPublisherList())!
  publisher.value = publisherList.value[0].publisherId
}

const init = (async () => {
  try {
    // 初期表示用のリクエスト
    await initialRequest()
  } catch (err) {
    handleErrors(err)
  }
})()

// タイトルのバリデーション
const titleErrorMessage = computed(() => {
  return $validation?.getErrorMessage(
    title.value,
    inputSettings,
    'title',
    true,
    false
  )
})

// 著者のバリデーション
const authorErrorMessage = computed(() => {
  return $validation?.getErrorMessage(
    author.value,
    inputSettings,
    'author',
    true,
    false
  )
})

// 刊行年(from)のバリデーション
const dateFromErrorMessage = computed(() => {
  return $validation?.getErrorMessage(
    dateFrom.value,
    inputSettings,
    'dateFrom',
    true,
    false
  )
})

// 刊行年(to)のバリデーション
const dateToErrorMessage = computed(() => {
  return $validation?.getErrorMessage(
    dateTo.value,
    inputSettings,
    'dateTo',
    true,
    false
  )
})

// 刊行年(from)と刊行年(to)のバリデーション
const dateBetweenErrorMessage = computed(() => {
  if (!dateFrom.value || !dateTo.value) return ''
  if (dateFromErrorMessage.value || dateToErrorMessage.value) return ''

  return Number(dateFrom.value) > Number(dateTo.value)
    ? '刊行年がまちがっています<br>左の刊行年 ＜ 右の刊行年で入力してください'
    : ''
})

return (_ctx: any,_cache: any) => {
  const _component_rb = _resolveComponent("rb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SlotModal, {
      icon: require('@/assets/image/icon/icon_search_advanced.svg'),
      onClose: close
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(AppCheckbox, {
            class: "searchDetails__head_checkbox",
            name: "searchDetails-area",
            displayName: "<ruby><rb>地域</rb><rp>(</rp><rt>ちいき</rt><rp>)</rp></ruby>の<ruby><rb>資料</rb><rp>(</rp><rt>しりょう</rt><rp>)</rp></ruby>のみをさがす",
            checked: area.value,
            onChange: onChangeArea
          }, null, 8, ["checked"])
        ])
      ]),
      actionArea: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("button", {
            class: "searchDetails__button animationLink",
            onClick: search
          }, [
            _createVNode(AppButton, {
              tag: "span",
              shadow: "m",
              rounded: "pill"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_85, [
                  _createElementVNode("span", _hoisted_86, [
                    _createVNode(AppImage, {
                      src: require('@/assets/image/icon/icon_search_advanced.svg'),
                      alt: "",
                      width: 32,
                      height: 32
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_87
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(AppCheckbox, {
            class: _normalizeClass(["searchDetails__actionArea__checkbox", _unref(disabledItem).className]),
            name: "searchDetails-learning",
            displayName: "<ruby>物語<rp>(<rt>ものがたり<rp>)</ruby><ruby>以外<rp>(<rt>いがい<rp>)</ruby>の<br class='spOnly'>本をさがす",
            checked: learning.value,
            onChange: onChangeLearning
          }, null, 8, ["class", "checked"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", {
                class: "searchDetails__item",
                ref_key: "focusInput",
                ref: focusInput
              }, [
                _createVNode(AppInput, {
                  id: "search-title",
                  modelValue: title.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                  errorMessages: _unref(titleErrorMessage),
                  onEnter: search
                }, null, 8, ["modelValue", "errorMessages"])
              ], 512)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ruby", null, [
                  _createVNode(_component_rb, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(AppInput, {
                  id: "search-author",
                  modelValue: author.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((author).value = $event)),
                  errorMessages: _unref(authorErrorMessage),
                  onEnter: search
                }, null, 8, ["modelValue", "errorMessages"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("ruby", null, [
                  _createVNode(_component_rb, null, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["searchDetails__item", _unref(disabledItem).className])
              }, [
                (publisherList.value.length)
                  ? (_openBlock(), _createBlock(AppSelect, {
                      key: 0,
                      modelValue: publisher.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((publisher).value = $event)),
                      itemValue: "publisherId",
                      itemTitle: "publisherName",
                      items: publisherList.value
                    }, null, 8, ["modelValue", "items"]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ruby", null, [
                  _createVNode(_component_rb, null, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(AppInput, {
                      id: "search-date-from",
                      modelValue: dateFrom.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateFrom).value = $event)),
                      errorMessages: 
                    _unref(dateBetweenErrorMessage) || _unref(dateFromErrorMessage) ? [''] : []
                  ,
                      onEnter: search
                    }, null, 8, ["modelValue", "errorMessages"])
                  ]),
                  _createElementVNode("span", _hoisted_26, [
                    _createElementVNode("ruby", null, [
                      _createVNode(_component_rb, null, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }),
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30
                    ]),
                    _hoisted_31
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(AppInput, {
                      id: "search-date-to",
                      modelValue: dateTo.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateTo).value = $event)),
                      errorMessages: 
                    _unref(dateBetweenErrorMessage) || _unref(dateToErrorMessage) ? [''] : []
                  ,
                      onEnter: search
                    }, null, 8, ["modelValue", "errorMessages"])
                  ]),
                  _createElementVNode("span", _hoisted_33, [
                    _createElementVNode("ruby", null, [
                      _createVNode(_component_rb, null, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }),
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37
                    ])
                  ])
                ]),
                (
                _unref(dateBetweenErrorMessage) ||
                _unref(dateFromErrorMessage) ||
                _unref(dateToErrorMessage)
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_unref(dateBetweenErrorMessage))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: _unref(dateBetweenErrorMessage)
                          }, null, 8, _hoisted_39))
                        : (_unref(dateFromErrorMessage))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              innerHTML: _unref(dateFromErrorMessage)
                            }, null, 8, _hoisted_40))
                          : (_unref(dateToErrorMessage))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                innerHTML: _unref(dateToErrorMessage)
                              }, null, 8, _hoisted_41))
                            : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                }),
                _hoisted_44,
                _hoisted_45,
                _hoisted_46
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(RadioGroup, {
                currentValue: grade.value,
                groupName: "grade",
                groupColor: "cyan",
                list: _unref(gradeList),
                onChange: onChangeGrade
              }, null, 8, ["currentValue", "list"])
            ])
          ], 2),
          (firstLayers.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
              }, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  (firstLayers.value.length)
                    ? (_openBlock(), _createBlock(RadioGroup, {
                        key: 0,
                        currentValue: first.value,
                        groupName: "first",
                        groupColor: "red",
                        list: firstLayers.value,
                        onChange: onChangeFirst
                      }, null, 8, ["currentValue", "list"]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (firstLayers.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
              }, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(RadioGroup, {
                    currentValue: second.value,
                    groupName: "second",
                    groupColor: "purple",
                    list: secondaryLayers.value,
                    onChange: onChangeSecond
                  }, null, 8, ["currentValue", "list"])
                ])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
          }, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_53
                  ]),
                  _: 1
                }),
                _hoisted_54,
                _hoisted_55,
                _hoisted_56
              ]),
              _hoisted_57,
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _hoisted_59,
                _hoisted_60,
                _hoisted_61
              ]),
              _hoisted_62,
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_63
                  ]),
                  _: 1
                }),
                _hoisted_64,
                _hoisted_65,
                _hoisted_66
              ]),
              _hoisted_67
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createVNode(RadioGroup, {
                currentValue: contentsStyle.value,
                groupName: "contentsStyle",
                groupColor: "green",
                list: _unref(contentsStyleList),
                onChange: onChangeContentsStyle
              }, null, 8, ["currentValue", "list"])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["searchDetails__group", _unref(disabledItem).className])
          }, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_70
                  ]),
                  _: 1
                }),
                _hoisted_71,
                _hoisted_72,
                _hoisted_73
              ]),
              _hoisted_74,
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_75
                  ]),
                  _: 1
                }),
                _hoisted_76,
                _hoisted_77,
                _hoisted_78
              ]),
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_79
                  ]),
                  _: 1
                }),
                _hoisted_80,
                _hoisted_81,
                _hoisted_82
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createVNode(RadioGroup, {
                currentValue: releaseEndDate.value,
                groupName: "contentsStyle",
                groupColor: "orange",
                list: _unref(releaseEndDateList),
                onChange: onChangeReleaseEndDate
              }, null, 8, ["currentValue", "list"])
            ])
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        (_unref(errorDialog).isVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
              _createVNode(SlotDialog, {
                type: "error",
                title: "<ruby><rb>入力</rb><rp>(</rp><rt>にゅうりょく</rt><rp>)</rp></ruby>した<ruby><rb>内容</rb><rp>(</rp><rt>ないよう</rt><rp>)</rp></ruby>をもう<ruby><rb>一度</rb><rp>(</rp><rt>いちど</rt><rp>)</rp></ruby><br>かくにんしてください",
                onClose: _unref(errorDialog).close
              }, null, 8, ["onClose"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})